module.exports = __webpack_public_path__ + "static/media/saved_port_marker.0ca38bfe.svg";